import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../../Common';
import { FormContext } from '../../../common/forms/FormElements';

export const useJobQuery = () => {
    const { values } = useContext(FormContext);
    const { jobDate, defaultTimesheetId } = values;

    const query = useQuery({
        queryKey: ['jobRequests', jobDate, defaultTimesheetId],
        queryFn: () => httpClient.js(ApiRoutes.jobRequests.forUser(moment(jobDate).format('YYYY-MM-DD'), defaultTimesheetId)),
    });

    return query;
};